<template>
    <b-card class="position-relative">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">{{$t('email.footers_management')}}</h4>

                <b-button class="ml-3" variant="primary" size="sm"
                          :disabled="isBusy"
                          @click.prevent="addNew">
                    <i class="icon-plus2"></i> {{$t('email.footers_add')}}
                </b-button>
            </div>
        </template>

        <div class="position-relative">
            <b-list-group flush v-if="footers.length > 0">
                <b-list-group-item href="#" v-for="footer in footers"
                    :key="footer.uuid"
                    class="d-flex justify-content-between align-items-center footer-list-item"
                    :disabled="isBusy"
                >
                    <span>
                        {{ footer.name }}
                        <b-badge pill variant="primary" v-if="footer.default" class="ml-1">{{$t('email.default_footer')}}</b-badge>
                    </span>
                    <div class="action-buttons">
                        <button-confirmation>
                            <template v-slot:confirm="slotProps">
                                <b-button variant="danger" size="sm" class="mr-1" @click="remove(footer.uuid)">{{$t('email.footer_remove_confirm_button')}}</b-button>
                            </template>
                            <template v-slot:cancel="slotProps">
                                <b-button variant="outline-success" size="sm" class="mr-1" @click="slotProps.hideConfirm()">{{$t('email.footer_remove_cancel_button')}}</b-button>
                            </template>
                            <template v-slot:default="slotProps">
                                <b-button variant="outline-danger" size="sm" class="mr-1" @click="slotProps.showConfirm()">{{$t('email.footer_remove_button')}}</b-button>
                                <b-button variant="secondary" size="sm" @click="edit(footer.uuid)">{{$t('email.footer_edit_button')}}</b-button>
                            </template>
                        </button-confirmation>
                    </div>

                </b-list-group-item>
            </b-list-group>
            <b-alert v-else show variant="light">{{$t('email.no_footers_created_alert')}}</b-alert>

            <div class="busy-notification" v-if="isBusy">
                <b-alert show variant="info"><fa-icon icon="spinner" class="mr-2" spin />{{ busyMessage }}</b-alert>
            </div>
        </div>

        <footer-modal
            :footer-data="footer"
            :is-visible="showModal"
            @closeModal="showModal = false"
            @updateList="updateList($event)"
        />
    </b-card>
</template>

<script>
import {fetchFooters, deleteFooter} from "./footersRepository";
import FooterModal from "./FooterModal";
import ButtonConfirmation from "../../../../../components/Utilities/ButtonConfirmation";
import SystemNotificator from "../../../../../services/SystemNotificator";

const DEFAULT_FOOTER_DATA = {
    uuid: null,
    name: '',
    content: '',
    default: false
}

export default {
    name: "FootersPanel",
    components: {FooterModal, ButtonConfirmation},
    mounted() {
        this.fetchAll()
    },
    methods: {
        fetchAll() {
            this.isBusy = true;
            this.busyMessage = this.$t('email.footers_downloading_message');
            fetchFooters()
                .then(({data}) => this.footers = data)
                .finally(() => this.isBusy = false)
        },
        addNew() {
            this.footer = {...DEFAULT_FOOTER_DATA};
            this.showModal = true;
        },
        edit(id) {
            this.footer = this.footers.find(footer => footer.uuid === id)
            this.showModal = true;
        },
        remove(id) {
            this.isBusy = true;
            this.busyMessage = this.$t('email.footers_removing_message');
            deleteFooter(id)
                .then(() => {
                    this.footers = this.footers.filter(footer => footer.uuid !== id);
                    SystemNotificator.success({title: this.$t('email.footers_removed_flash_message')});
                })
                .finally(() => {
                    this.isBusy = false;
                    this.busyMessage = '';
                })
        },
        updateList({data, isNew}) {
            if (data.default) {
                // remove default flag from other templates
                this.footers.forEach(footer => footer.default = false);
            }
            if (isNew) {
                this.footers.push(data);
            } else {
                this.footers = this.footers.map(footer => {
                    if (footer.uuid === data.uuid) {
                        footer = {...footer, ...data}
                    }
                    return footer;
                });
            }
        }
    },
    data: () => ({
        footers: [],
        footer: DEFAULT_FOOTER_DATA,
        showModal: false,

        busyMessage: '',
        isBusy: false
    })
}
</script>

<style scoped lang="scss">
    .list-group.list-group-flush {
        margin: 0;
        padding: 0;
        .list-group-item {
            border-top: 1px solid rgba(0,0,0,.125) !important;
        }
    }

    .footer-list-item {
        padding: 5px;
        .action-buttons {
            visibility: hidden;
        }
        &:hover {
            .action-buttons {
                visibility: visible;
            }
        }
    }

    .busy-notification {
        position: absolute;
        z-index: 10;
        top: 0;
        margin: 0 auto;
        left: 0;
        right: 0;
        width: 50%;
        text-align: center;
    }
</style>